module.exports = __webpack_public_path__ + "img/placeholder3.4f53756b.png";